module.exports = "<p>\n  agent-details works!\n</p>\n"